/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadSecurityGeneralQuery {
        systemSettings(section: sso)
    }
`;
